export default __webpack_public_path__ + "images/pictograms/change-password.svg?76adba6d1e18f0fa5666add647782363997cce358782440e818d18321a6dcbd5";